<template>
  <section class="video-links">
    <p class="heading">{{ heading }}</p>
    <div
      v-for="(video, index) in videos"
      :key="index"
    >
      <a
        :href="video.url"
        class="video"
        target="_blank"
        title="Watch this video"
      >
        {{ video.title }}
        <img src="@/assets/icon_play-blk.svg" alt="Play video icon">
      </a>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'videolink',

    props: {
      heading: String,
      videos: Array
    }
  }
</script>

<style lang="scss" scoped>
.video-links {
  background-color: rgba(255,255,255,0.75);
  width: calc(100% + 40px);
  margin-left: -20px;
  margin: 30px 0 40px -20px;
  padding: 20px 20px 40px;
  max-width: none;
}

.heading {
  font-family: var(--roboto);
  font-size: 1rem;
  line-height: 1.3125;
  font-weight: 700;
  color: var(--black);
}

.video img {
  width: 33px;
}

a.video {
  font-family: var(--roboto);
  text-decoration: none;
  font-size: 0.875rem;
  color: var(--black);
  border-bottom: 1px solid #969696;
  padding: 10px 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

div:first-of-type {
  border-top: 1px solid #969696;
}
</style>